/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { modifyWorkScheduleAssign } from "../../../../apis/work-schedule";
import Form from "../../../../components/Form";
import Modal, { ModalHeader } from "../../../../components/Modal";
import useForm from "../../../../hooks/useForm";
import { getDay } from "../../../../utils/date";

const ApplyDate = ({ defaultDate, open, setOpen, selectedList, submit }) => {
  const [formFields] = [
    [
      {
        title: "적용일",
        key: "applyStartDate",
        type: "datepicker",
        detail: "datepicker",
        required: true,
        defaultValue: defaultDate || "",
        options: { minDate: getDay() },
      },
    ],
  ];

  const validate = ({ applyStartDate }) => {
    let errors = {};
    if (!applyStartDate) errors.applyStartDate = "적용일은 필수입니다.";
    return errors;
  };

  const _submit = (form) => {
    const transForm = {
      assignIdxs: selectedList,
      applyStartDate: form.applyStartDate.toString(),
    };

    modifyWorkScheduleAssign(transForm)
      .then(() => {
        submit();
        setOpen(false);
      });
  };

  const { form, errors, handleOnChange, handleSubmit } = useForm(
    {
      applyStartDate: "",
    },
    _submit,
    validate
  );

  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="apply-date-write">
        <ModalHeader>적용일 수정</ModalHeader>
        <Form
          fields={formFields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default ApplyDate;
